export default __webpack_public_path__ + "static/media/mon_64.16202d1a.png";